import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {isNumeric} from 'rxjs/internal-compatibility';
import {environment} from "../../../environments/environment";
import {TYPE_OPERACION} from "../models/constants";

@Injectable({
    providedIn: 'root'
})
export class UtilityService {

    constructor(

    ) {
    }
    public PARAM = environment.PARAM;
    CDN_BASE = environment.CDN_BASE;
    HTTP_RESPONSE = environment.HTTP_RESPONSE;
    public placeholderBusqueda = '';
    public static localhost = 'localhost';
    public TIPO_BUSQUEDA = {
        BK: 1,
        LISTA_BK: 2
    };
    public tipobusqueda = this.TIPO_BUSQUEDA.BK;
    public bookingFiltroList : any[] = [];

    public isVisibleTypeName(documentoList: any[] = [], filesObj: any = {}){

        const selected = documentoList.find((documento) => documento.documento_id === filesObj.files_type);

        if(selected){
            return selected.documento_enabledinput;
        }

        return false;

    }

    public obtenerAnioActual() {
        return new Date().getFullYear();
    }

    public verificarTipoBusqueda(busqueda: any){
        if(this.tipobusqueda == this.TIPO_BUSQUEDA.LISTA_BK){
            if(this.validarInputSearch(busqueda) != this.PARAM.TODOS){
                const busqueda_input = busqueda.toUpperCase().trim();
                if(busqueda_input.includes(" ")){
                    for (let busqueda of busqueda_input.split(" ")){
                        this.bookingFiltroList.push(busqueda);
                    }
                }else if(busqueda_input.includes(",")){
                    for (let busqueda of busqueda_input.split(",")){
                        this.bookingFiltroList.push(busqueda);
                    }
                }else{
                    this.bookingFiltroList.push(busqueda_input);
                }
                this.bookingFiltroList = this.deleteDuplicatesArray(this.bookingFiltroList);
            }
        }
    }

    public fnPlaceholderBusqueda(){
        if(this.tipobusqueda == this.TIPO_BUSQUEDA.BK){
            this.placeholderBusqueda = 'Buscar por BK/Referencia...';
        }else{
            this.placeholderBusqueda = 'BK/Referencia (Enter Agregar)';
        }
    }

    public deleteListBooking(){
        this.bookingFiltroList.length = 0;
    }

    public eliminarBKLista(index: number){
        this.bookingFiltroList.splice(index, 1);
    }

    public obtenerListaMeses() {
        return [{
            label: 'Enero',
            value: 1
        }, {
            label: 'Febrero',
            value: 2
        }, {
            label: 'Marzo',
            value: 3
        }, {
            label: 'Abril',
            value: 4
        }, {
            label: 'Mayo',
            value: 5
        }, {
            label: 'Junio',
            value: 6
        }, {
            label: 'Julio',
            value: 7
        }, {
            label: 'Agosto',
            value: 8
        }, {
            label: 'Septiembre',
            value: 9
        }, {
            label: 'Octubre',
            value: 10
        }, {
            label: 'Noviembre',
            value: 11
        }, {
            label: 'Diciembre',
            value: 12
        }];
    }

    public getColorsGraphic(){
        return '["#0274bb", "#02cccd", "#a5a5a5", "#ffbc58", "#8AA64C", "#ff8084", "#ff7f83", "#f0b54d", "#13c9ca", "#01cccd"]';
    }

    public deleteDuplicatesArray(array: any[]){
        return [...new Set(array)];
    }


    public getRangeLabel = (page: number, pageSize: number, length: number) =>  {
        if(page > 0){
            page = page - 1;
        }
        if (length === 0 || pageSize === 0) {
            return `0 de ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `Resultados <span class="fw-semibold">${startIndex + 1}</span> - <span class="fw-semibold">${endIndex}</span> de <span class="fw-semibold">${length}</span>`;
    }

    public esUnIDValido(id: string) {
        return isNumeric(id) && parseInt(id) > 0;
    }

    public abrirFichero(fichero: any) {
        if(fichero){
            window.open(this.CDN_BASE + fichero, '_blank');
        }
    }


    public obtenerFormatoVistaDDMMYYY(fecha:any) {
        return this.formatearFecha(fecha, 'DD/MM/yyyy');
    }

    public obtenerFormatoBD(fecha:any) {
        return this.formatearFecha(fecha, 'yyyy-MM-DD');
    }

    public obtenerInicioDeMes() {
        var fechaActual = new Date();
        return new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    }

    public obtenerFormatoVistaHora(fecha:any) {
        return this.formatearFecha(fecha, 'hh:mm A');
    }

    public obtenerFormatoVistaHoraFull(fecha:any) {
        return this.formatearFecha(fecha, 'HH:mm');
    }

    public formatearFecha(fecha:any, formato:any): any {
        let fechaSeteada = '';
        if (fecha && fecha !== '-') {
            fechaSeteada = moment(fecha).format(formato);
        }
        return fechaSeteada;
    }

    public obtenerFormatoVistaAMPM(fecha: any) {
        return this.formatearFecha(fecha, 'DD/MM/yyyy') + ' ' + this.formatearFecha(fecha, 'hh:mm A');
    }

    public getPesoVGM(taraContenedor: number, pesoBruto: number) {
        return Number(taraContenedor) + Number(pesoBruto);
    }

    public getTaraCamion(pesocamion: any, pesoBruto: any) {
        if (pesocamion * 1 > pesoBruto * 1)
            return pesocamion - pesoBruto;
        else
            return 0;
    }

    public arrayUniqueList(key: any, arr: any[]) {
        return [...new Map(arr.map(item => [item[key], item])).values()]
    }

    public valorEstaVacio(valor: any){
        return (valor == null || valor == "");
    }


    public validarInputSearch(busqueda: any) {
        if (busqueda != undefined && busqueda != null && busqueda != "") {
            if (!Number.isNaN(busqueda)) {
                return busqueda.trim();
            } else {

                const texto = busqueda.replace(/[^\w\s]/gi, '');
                if (texto == '') {
                    return this.PARAM.TODOS;
                }
                return texto.trim();
            }

        }
        return this.PARAM.TODOS;
    }

    public goBack() {
        window.history.back();
    }
    public closeWindow() {
        window.close();
    }

    /**
     * Parsers data
     */
    public parseData(data: any, tablaDescripcion?: string, tablaId?: string): any {
        let dataObj = {tipo: this.HTTP_RESPONSE.MALFORMED_JSON, mensajes: ['JSON mal formado', data], data: null};
        if (data !== null && typeof data === 'object') {
            if (data.data !== null && typeof data.data === 'object') {
                dataObj = data;
                if (!data.tipo) {
                    dataObj.tipo = this.HTTP_RESPONSE.SUCCESS;
                }
            } else {
                /**
                 * Si la respuesta es pura sin tipo ni mensajes seteo data a la respuesta
                 */
                if (data.data && data.tipo && data.mensajes) {
                    dataObj = data;
                } else {
                    if (!data.tipo && !data.mensajes) {
                        dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: [], data};
                        if (data.mensajes && Array.isArray(data.mensajes)) {
                            dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: data.mensajes, data};
                        }
                        if (data.mensajes && !Array.isArray(data.mensajes)) {
                            dataObj = {tipo: this.HTTP_RESPONSE.SUCCESS, mensajes: [data.mensajes], data};
                        }
                    } else {
                        if (data.tipo === this.HTTP_RESPONSE.PERMISION_ERROR) {
                            dataObj = data;
                        }
                        if (data.tipo === this.HTTP_RESPONSE.SUCCESS) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.WARNING) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.INFO) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                dataObj = {tipo: data.tipo, mensajes: data.mensajes, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                        if (data.tipo === this.HTTP_RESPONSE.ERROR) {
                            if (data.mensajes && Array.isArray(data.mensajes)) {
                                /**
                                 * Si la respuesta tiene alguno de los siguientes problemas parseo
                                 * la respuesta indicando el origen del problema
                                 */
                                    // tslint:disable-next-line:max-line-length
                                const mensajeServidorError = this.parseResponseErrorDatabase(data.mensajes, tablaDescripcion, tablaId);
                                dataObj = {tipo: data.tipo, mensajes: mensajeServidorError, data};
                            } else {
                                dataObj = {tipo: data.tipo, mensajes: [data.mensajes], data};
                            }
                        }
                    }
                }
            }
        }
        return dataObj;
    }

    public parseResponseErrorDatabase(mensajes: any[], tablaDescripcion: string | undefined, tablaId: string | undefined) {
        let mensajeArrayProcesada = [];

        mensajes.forEach(error => {
            /**
             * Pregunto si el error es por algun fk delete
             */
            if (error.includes('Cannot delete or update a parent row: a foreign key constraint fails')) {
                // tslint:disable-next-line:max-line-length
                mensajeArrayProcesada.push('El elemento con ID "' + tablaId + '" de la tabla "' + tablaDescripcion + '" está referenciado en otra(s) tabla(s), ' +
                    'por favor contacta al admininistrador para notificar el problema e ' +
                    'indicale el id y la tabla que tienen problemas.');
            }
        });

        if (!mensajeArrayProcesada.length) {
            mensajeArrayProcesada = mensajes;
        }

        return mensajeArrayProcesada;
    }

    public isMobile(){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            return true;
        }

        return false;
    }

    public static getSubdomain(): string {
        let hostname = window.location.hostname;
        let urlParts = hostname.split(".");

        if (Array.isArray(urlParts) && urlParts.length > 0 ) {
            return  urlParts[0];
        }

        return hostname;

    }

    public isAPM(){

        return UtilityService.getSubdomain() == "apm";

    }

    public getTipoOperaciones(){
        return [
            { id:  TYPE_OPERACION.MARITIMO, name: TYPE_OPERACION.MARITIMO_TEXT},
            { id:  TYPE_OPERACION.AEREO, name: TYPE_OPERACION.AEREO_TEXT},
            { id:  TYPE_OPERACION.TERRESTRE, name: TYPE_OPERACION.TERRESTRE_TEXT},
        ];
    }

    public validRegexComprobante(codigo: string): boolean {
        const regex = /^[A-Z0-9]{1,4}-\d{1,8}$/;
        return regex.test(codigo);
    }

    /**
     * Obtiene el ícono según la extensión del archivo (Material Design Icons)
     */
    getFileIcon(fileName?: string): string {
        if (!fileName) return 'mdi mdi-file-outline text-secondary';

        const ext = fileName.split('.').pop()?.toLowerCase();

        switch (ext) {
            case 'pdf':
                return 'mdi mdi-file-pdf-box text-danger'; // Rojo
            case 'doc':
            case 'docx':
                return 'mdi mdi-file-word-box text-primary'; // Azul
            case 'xls':
            case 'xlsx':
                return 'mdi mdi-file-excel-box text-success'; // Verde
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'bmp':
            case 'svg':
                return 'mdi mdi-file-image-outline text-info'; // Azul claro
            case 'zip':
            case 'rar':
            case '7z':
                return 'mdi mdi-folder-zip-outline text-warning'; // Amarillo
            case 'txt':
                return 'mdi mdi-file-document-outline text-muted'; // Gris
            case 'ppt':
            case 'pptx':
                return 'mdi mdi-file-powerpoint-box' ; // Naranja (usa color inline)
            default:
                return 'mdi mdi-file-outline text-secondary'; // Gris por defecto
        }
    }

    public getChartColorsArray(colors:any) {
        colors = JSON.parse(colors);
        return colors.map(function (value:any) {
            var newValue = value.replace(" ", "");
            if (newValue.indexOf(",") === -1) {
                var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
                if (color) {
                    color = color.replace(" ", "");
                    return color;
                }
                else return newValue;;
            } else {
                var val = value.split(',');
                if (val.length == 2) {
                    var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
                    rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
                    return rgbaColor;
                } else {
                    return newValue;
                }
            }
        });
    }


}

